import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import Layout from '../../containers/Layout';
import NotificationsForm from './NotificationsForm';
import SettingsDrawer from './components/SettingsDrawer';
export const defaultUrl = '/notifications';
class SettingsNotificationsPage extends Component {
    render() {
        const { user, match, t } = this.props;
        return (_jsx(Layout, { title: t('settings.notifications'), loginRequired: true, withDrawer: true, match: match, loading: !user.user, titlePrimary: t('settings.settings'), children: _jsx("div", { className: "container repository-detail__container", children: _jsxs("div", { className: "row", children: [_jsx(SettingsDrawer, { className: "col col-12 col-md-2" }), _jsxs("div", { className: "col col-12 col-md-10 repository-detail__content", children: [_jsx("h2", { className: "repository-detail__title", children: t('settings.notifications') }), _jsx(NotificationsForm, {})] })] }) }) }));
    }
}
const mapStateToProps = (state) => ({
    user: state.user,
});
// const mapDispatchToProps = dispatch => ({
// 	dispatch: dispatch,
// });
export default connect(mapStateToProps /*, mapDispatchToProps*/)(withTranslation()(SettingsNotificationsPage));
